// Avatar generation utilities using DiceBear API
// https://api.dicebear.com/9.x/

export interface AvatarOptions {
  style?: 'avataaars' | 'personas' | 'micah' | 'adventurer' | 'big-smile' | 'bottts' | 'croodles' | 'fun-emoji' | 'icons' | 'identicon' | 'initials' | 'lorelei' | 'notionists' | 'open-peeps' | 'pixel-art' | 'rings' | 'shapes' | 'thumbs';
  seed?: string;
  backgroundColor?: string;
  size?: number;
}

export const generateAvatarUrl = (options: AvatarOptions = {}): string => {
  const {
    style = 'avataaars',
    seed = Math.random().toString(36).substring(7),
    backgroundColor = 'transparent',
    size = 200
  } = options;

  const params = new URLSearchParams({
    seed,
    backgroundColor,
    size: size.toString()
  });

  return `https://api.dicebear.com/9.x/${style}/svg?${params.toString()}`;
};

// Generate avatar for outlet based on outlet_id
export const generateOutletAvatar = (outletId: string, style: AvatarOptions['style'] = 'avataaars'): string => {
  return generateAvatarUrl({
    style,
    seed: outletId,
    size: 200
  });
};

// Generate random avatar for new users
export const generateRandomAvatar = (style: AvatarOptions['style'] = 'avataaars'): string => {
  return generateAvatarUrl({
    style,
    size: 200
  });
};

// Predefined avatar styles for different outlet types
export const getAvatarStyleForOutletType = (outletType: string): AvatarOptions['style'] => {
  const typeMap: Record<string, AvatarOptions['style']> = {
    'supermarket': 'avataaars',
    'convenience': 'personas', 
    'restaurant': 'micah',
    'cafe': 'adventurer',
    'pharmacy': 'big-smile',
    'gas_station': 'bottts',
    'default': 'avataaars'
  };
  
  return typeMap[outletType.toLowerCase()] || typeMap.default;
};

// Avatar component props helper
export const getAvatarProps = (outletId: string, outletType?: string, customStyle?: AvatarOptions['style']) => {
  const style = customStyle || getAvatarStyleForOutletType(outletType || 'default');
  return {
    src: generateOutletAvatar(outletId, style),
    alt: `Outlet ${outletId} avatar`,
    style: { width: '100%', height: '100%' }
  };
};
